import BgColorChange from './bgcolorChange';

const bgColorChange = new BgColorChange();

export default class MegaNaviPC {
    constructor($navi,$naviList,$overlay){
        this.$navi = $navi;
        this.$naviList = $naviList;
        this.$dropdownNavi = $(".l-header__meganavi");
        this.$overlay = $overlay;

        this.hoverTime;

        this.src = 0;
    }
    init(){

        let _this = this;

        _this.$naviList.on({
            'mouseenter':function(){
                let $target = $(this);
                _this.hoverTime = setTimeout(function(){
                    if($('html.tablet')[0] || $(window).width() < 750) return false;
                    _this.meganavi($target,'show');
                    $('#l-header').removeClass('transparent');
                    $('body').addClass('meganavi-open');
                    // $(document).on(header.MOUSEWHEEL,function(e) {
                    //     e.preventDefault();
                    // });
                },350);
            },
            'mouseleave':function(){
                if($('html.tablet')[0] || $(window).width() < 750) return false;
                let $target = $(this);
                _this.meganavi($target,'hide');
                _this.scr = $(window).scrollTop();
                // header.color(scr);
                bgColorChange.update(_this.scr,$('#l-kv').height(),$('#l-header').height());
                $('body').removeClass('meganavi-open');
                clearTimeout(_this.hoverTime);
            }
        });

    }
    meganavi ($target,type){
        switch (type) {
            case 'hide': // --------------- hide --------------- //
                // motion
                $target.removeClass('hover');
                TweenMax.to($target.find(this.$dropdownNavi), 0.12, {
                    delay:0.14,
                    y: '-5px',
                    display: 'none',
                    opacity:0,
                    ease: Circ.easeOut
                });
                TweenMax.staggerTo($target.find(this.$dropdownNavi).find('.l-header__meganavi-list'), 0.26, {
                        delay:0.12,
                        y: '-5px',
                        opacity:0,
                        ease: Sine.easeOut
                    },0.08
                );
                TweenMax.to(this.$overlay, 0.12, {
                    delay:0.14,
                    display: 'none',
                    opacity:0,
                    ease: Circ.easeOut
                });
                break; // --------------- hide (end) --------------- //

            case 'show': // --------------- show (start) --------------- //
                // motion
                $target.addClass('hover');
                //TweenMax.killTweensOf($target.find(this.$dropdownNavi).find('.l-header__meganavi-list'));
                TweenMax.killTweensOf(this.$overlay);
                TweenLite.set($target.find(this.$dropdownNavi), {
                        y: '-5px',
                        display: 'none',
                        opacity:0
                    }
                );
                TweenLite.set($target.find(this.$dropdownNavi).find('.l-header__meganavi-list'), {
                        y: '-5px',
                        opacity:0
                    }
                );
                TweenMax.to($target.find(this.$dropdownNavi), 0.12, {
                        y: '0',
                        display: 'block',
                        opacity:1,
                        ease: Circ.easeOut
                    }
                );
                TweenMax.staggerTo($target.find(this.$dropdownNavi).find('.l-header__meganavi-list'), 0.22, {
                        delay:0.06,
                        y: '0',
                        opacity:1,
                        ease: Sine.easeOut
                    },0.08
                );
                TweenMax.to(this.$overlay, 0.12, {
                        display: 'block',
                        opacity:1,
                        ease: Circ.easeOut
                    }
                );
                break; // --------------- show (end) --------------- //
        }
    }
    resize(){
        this.$navi.removeAttr('style');
        this.$dropdownNavi.removeAttr('style');

    }
}